import { render, staticRenderFns } from "./Enlaces.vue?vue&type=template&id=190ddb72"
import script from "./Enlaces.vue?vue&type=script&lang=js"
export * from "./Enlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports